import type { GetPendingPointScheduleResponseDataDto } from 'viewup-api/v2';

export const sumPendingPoint = (schedule?: GetPendingPointScheduleResponseDataDto[]): number => {
  const sum = (schedule ?? []).reduce((acc, { point }) => acc + point, 0);

  return sum < 0 ? 0 : sum;
};
